import React, { useContext, useState } from "react";
import { storeContext } from "./../../../global/store";
//Material UI
import { IconButton } from "@mui/material";
//Icons
import AttachFileIcon from "@mui/icons-material/AttachFile";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import Switch from "react-switch";

const OverviewSection = () => {
  const { store, setStore } = useContext(storeContext);

  const [checked, setChecked] = useState(
    store.layout === "side" ? false : true,
  );

  const handleChange = (nextChecked) => {
    setChecked(nextChecked);
    setStore({ ...store, triggerAnimation: true });
    setTimeout(() => {
      setStore({ ...store, layout: "block" });
    }, 1100);
  };

  return (
    <section
      id="OverviewSection"
      className="h-full flex flex-col items-center space-y-6"
    >
      <div className="flex flex-row items-center justify-center w-2/3 md:w-1/2">
        <div className="w-[220px] h-[220px] rounded-full avatar-image"></div>
      </div>
      <div className="flex flex-col items-center justify-center space-x-2 w-2/3 md:w-1/2">
        <div className="space-y-8 text-center">
          <h1 className="text-5xl leading-tight">
            Hi there <span>👋🏼</span> <span>👀</span>
          </h1>
          <p className="text-sm font-normal leading-loose opacity-60">
            I'm Badreddin Labed, a Professional Senior Software Engineer who
            specializes in{" "}
            <span className=" underline decoration-2 decoration-[#000]">
              JavaScript & TypeScript
            </span>
            , I can help you solve a problem, build a product or grow an
            existing project.
          </p>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center space-x-2 w-2/3 md:w-1/2">
        <label className="flex flex-row items-center justify-center space-x-4">
          <span className="text-sm font-normal leading-loose opacity-60">
            Horizontal
          </span>
          <Switch
            onChange={handleChange}
            checked={checked}
            onColor="#000"
            className="react-switch"
            data-umami-event="switch-from-horizontal"
          />
        </label>
      </div>
      <div className="w-2/3 md:w-1/2 flex flex-col items-center justify-center">
        <div className="flex space-x-1 items-center justify-center">
          <a
            href="https://drive.google.com/file/d/1QJ-eS1uU6oJbuDWotwkLCXzylThb0MXu/view"
            target="_blank"
            rel="noreferrer"
            data-umami-event="clicked-cv-side"
          >
            <IconButton>
              <AttachFileIcon className=" hover-icon-animation" />
            </IconButton>
          </a>
          <a
            href="mailto:badreddin.labed@mindera.com"
            target="_blank"
            rel="noreferrer"
            data-umami-event="clicked-mail-side"
          >
            <IconButton>
              <EmailIcon className=" hover-icon-animation" />
            </IconButton>
          </a>
          <a
            href="https://www.linkedin.com/in/badreddin-labed/"
            target="_blank"
            rel="noreferrer"
            data-umami-event="clicked-linkedin-side"
          >
            <IconButton>
              <LinkedInIcon className=" hover-icon-animation" />
            </IconButton>
          </a>
        </div>
        <div className="text-sm font-normal leading-loose opacity-60 text-center space-x-1">
          <span>All rights reserved to</span>
          <span className="text-primary-color">Badreddin Labed</span>
          <span>© 2019-{new Date().getFullYear()}</span>
        </div>
      </div>
    </section>
  );
};

export default OverviewSection;
